export function setupDirectoryModule( container ) {
	const baseUrl = container.dataset.baseUrl;
	const fetchUrl = container.dataset.fetchUrl;

	const forms = container.querySelectorAll( 'form' );

	const liveArea = container.querySelector( '[aria-live]' );
	const filtersWrapper = container.querySelector( '.js-directory-filters' );
	const statsWrapper = container.querySelector( '.js-directory-stats' );
	const sortWrapper = container.querySelector( '.js-directory-sort' );
	const navbarWrapper = container.querySelector( '.js-directory-navbar' );
	const tagsWrapper = container.querySelector( '.js-directory-tags' );
	const resultsWrapper = container.querySelector( '.js-directory-results' );
	const paginationWrappers = container.querySelectorAll( '.js-directory-pagination' );

	const language = document.documentElement.lang.substring( 0, 2 ) || 'en';
	const format = resultsWrapper.dataset.format;

	function fetchResults( page = 1 ) {
		const params = new URLSearchParams();
		forms.forEach( form => {
			const data = new FormData( form );
			for ( const [ key, value ] of data.entries() ) {
				if ( value ) {
					params.append( key, value );
				}
			}
		} );

		if ( page > 1 ) {
			params.append( 'paged', page );
		}

		const query = params.toString();
		history.replaceState( null, '', baseUrl + ( query ? `?${ query }` : '' ) );

		params.append( 'nl_language', language );
		params.append( 'format', format );

		container.classList.add( 'loading' );

		return fetch( fetchUrl + '?' + params.toString() )
			.then( response => {
				if ( ! response.ok ) {
					throw new Error( `Directory Request Status: ${ response.status }` );
				}

				return response.json();
			} )
			.then( response => {
				if ( statsWrapper ) {
					statsWrapper.hidden = ! response.stats;
					statsWrapper.innerHTML = response.stats;
				}

				if ( sortWrapper ) {
					sortWrapper.hidden = ! response.sort;
					sortWrapper.innerHTML = response.sort;
				}

				if ( navbarWrapper ) {
					navbarWrapper.hidden = ! response.navbar;
					navbarWrapper.innerHTML = response.navbar;
				}

				if ( tagsWrapper ) {
					tagsWrapper.hidden = ! response.tags;
					tagsWrapper.innerHTML = response.tags;
				}

				if ( resultsWrapper ) {
					let results = response.results;
					if ( results instanceof Array ) {
						results = results.join( '\n' );
					}

					resultsWrapper.hidden = ! results;
					resultsWrapper.innerHTML = results;
				}

				paginationWrappers.forEach( wrapper => {
					wrapper.hidden = ! response.pagination;
					wrapper.innerHTML = response.pagination;
				} );

				container.classList.remove( 'loading' );
			} )
			.catch( () => {
				// do nothing
			} )
			.finally( () => {
				liveArea.setAttribute( 'aria-busy', false );
				liveArea.focus();

				if ( window.scrollY > container.offsetTop ) {
					container.scrollIntoView( true );
				}
			} );
	}

	forms.forEach( form => {
		form.addEventListener( 'submit', event => {
			event.preventDefault();
			fetchResults();
		} );
	} );

	filtersWrapper?.addEventListener( 'input', event => {
		const form = event.target.closest( 'form' );
		if ( typeof form.requestSubmit === 'function' ) {
			form.requestSubmit();
		} else {
			form.dispatchEvent( new Event( 'submit' ) );
		}
	} );

	container.addEventListener( 'click', event => {
		const target = event.target.closest( 'a' ) || event.target;

		if ( target.dataset.page ) {
			event.preventDefault();
			fetchResults( target.dataset.page );
		} else
			if ( target.dataset.filter ) {
				event.preventDefault();

				const [ name, value = null ] = target.dataset.filter.split( ':' );
				container.querySelectorAll( `[name="${ name }"]` ).forEach( input => {
					input.checked = input.value === value;
				} );

				fetchResults();
			} else
				if ( target.dataset.clear ) {
					event.preventDefault();

					const [ name, value = null ] = target.dataset.clear.split( ':' );

					let inputs = container.querySelectorAll( 'input.js-clearable' );
					if ( name !== 'ALL' ) {
						inputs = container.querySelectorAll( `[name="${ name }"], [name="${ name }[]"]` );
					}

					inputs.forEach( input => {
						if ( value === null || input.value === value ) {
							if ( input.type === 'checkbox' || input.type === 'radio' ) {
								input.checked = false;
							} else {
								input.value = '';
							}
						}
					} );

					fetchResults();
				}
	} );
}

export default function setupDirectoryModules() {
	document.querySelectorAll( '.js-directory' ).forEach( setupDirectoryModule );
}
